(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jomi-saved-strip"] && !Shopify.designMode) return;
  try {
    (function() {
    var SAVE_KEY = 'jomi_wishlist';

    function money(cents) {
      // Use shared Jomi.formatMoney which respects shop's money_format (v44 currency fix).
      if (window.Jomi && typeof Jomi.formatMoney === 'function') {
        return Jomi.formatMoney(cents);
      }
      // Fallback if Jomi not yet loaded
      try {
        var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: currency
        }).format(cents / 100);
      } catch (e) {
        var amt = (cents / 100).toFixed(2);
        return amt.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    }

    function escapeAttr(s) {
      return (s || '').toString().replace(/[<>&"']/g, function(c) {
        return { '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function getList() {
      try {
        var raw = localStorage.getItem(SAVE_KEY);
        return raw ? JSON.parse(raw) : [];
      } catch (e) {
        return [];
      }
    }

    function setList(list) {
      try {
        localStorage.setItem(SAVE_KEY, JSON.stringify(list));
      } catch (e) { /* quota exceeded, ignore */ }
    }

    function buildCard(product) {
      var img = product.featured_image || (product.images && product.images[0]) || '';
      var imgSrc = typeof img === 'string' ? img : (img && img.src) || '';
      if (imgSrc && imgSrc.indexOf('//') === 0) imgSrc = 'https:' + imgSrc;
      if (imgSrc) {
        imgSrc = imgSrc.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_400x$1$3');
      }

      var url = product.url || ('/products/' + product.handle);
      var title = product.title || '';
      var price = money(product.price);

      var card = document.createElement('article');
      card.className = 'jomi-saved-card';
      card.setAttribute('data-handle', product.handle);

      card.innerHTML =
        '<button type="button" class="jomi-saved-card__remove" ' +
          'data-jomi-saved-remove="' + escapeAttr(product.handle) + '" ' +
          'aria-label="Remove ' + escapeAttr(title) + ' from saved">×</button>' +
        '<a href="' + escapeAttr(url) + '" class="jomi-saved-card__link">' +
          '<div class="jomi-saved-card__image-wrap">' +
            (imgSrc ? '<img src="' + escapeAttr(imgSrc) + '" alt="' + escapeAttr(title) + '" class="jomi-saved-card__image" loading="lazy">' : '') +
          '</div>' +
          '<h3 class="jomi-saved-card__title">' + escapeAttr(title) + '</h3>' +
          '<p class="jomi-saved-card__price">' + escapeAttr(price) + '</p>' +
        '</a>';
      return card;
    }

    function initStrip(strip) {
      var track = strip.querySelector('[data-jomi-saved-track]');
      var countEl = strip.querySelector('[data-saved-count]');
      var countLabel = strip.querySelector('[data-saved-count-label]');
      if (!track) return;

      var handles = getList();
      if (!handles.length) {
        strip.hidden = true;
        return;
      }

      Promise.all(handles.map(function(handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function(r) { return r.ok ? r.json() : null; })
          .catch(function() { return null; });
      }))
      .then(function(products) {
        products = products.filter(function(p) { return p; });

        var liveHandles = products.map(function(p) { return p.handle; });
        if (liveHandles.length !== handles.length) {
          setList(liveHandles);
        }

        if (!products.length) {
          strip.hidden = true;
          return;
        }

        track.innerHTML = '';
        products.forEach(function(p) {
          track.appendChild(buildCard(p));
        });

        if (countEl) countEl.textContent = products.length;
        if (countLabel) countLabel.textContent = products.length === 1 ? 'piece' : 'pieces';

        strip.hidden = false;

        track.querySelectorAll('[data-jomi-saved-remove]').forEach(function(btn) {
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var handle = btn.getAttribute('data-jomi-saved-remove');
            var list = getList().filter(function(h) { return h !== handle; });
            setList(list);
            var card = btn.closest('.jomi-saved-card');
            if (card) {
              card.style.transition = 'opacity 0.25s ease, transform 0.25s ease';
              card.style.opacity = '0';
              card.style.transform = 'scale(0.96)';
              setTimeout(function() {
                if (card.parentNode) card.parentNode.removeChild(card);
                var remaining = track.querySelectorAll('.jomi-saved-card').length;
                if (remaining === 0) {
                  strip.hidden = true;
                } else {
                  if (countEl) countEl.textContent = remaining;
                  if (countLabel) countLabel.textContent = remaining === 1 ? 'piece' : 'pieces';
                }
              }, 250);
            }
          });
        });
      })
      .catch(function(err) {
        console.warn('[JOMI saved] fetch error:', err);
        strip.hidden = true;
      });
    }

    function initAll() {
      document.querySelectorAll('[data-jomi-saved-strip]').forEach(initStrip);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('cart:drawer:opened', initAll);
    document.addEventListener('cart:updated', function() {
      setTimeout(initAll, 100);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
